import _classCallCheck from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/createClass";

var AmpEnvelope =
/*#__PURE__*/
function () {
  function AmpEnvelope(context) {
    var gain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, AmpEnvelope);

    this.context = context;
    this.output = this.context.createGain();
    this.output.gain.value = gain;
    this.partials = [];
    this.velocity = 0;
    this.gain = gain;
    this._attack = 0;
    this._decay = 0.001;
    this._sustain = this.output.gain.value;
    this._release = 0.001;
    this.maxTime = 2;
  }

  _createClass(AmpEnvelope, [{
    key: "on",
    value: function on(velocity) {
      this.velocity = velocity / 127;
      this.start(this.context.currentTime);
    }
  }, {
    key: "off",
    value: function off(MidiEvent) {
      return this.stop(this.context.currentTime);
    }
  }, {
    key: "start",
    value: function start(time) {
      var attackTime = this.attack * this.maxTime;
      var decayTime = this.decay * this.maxTime;
      this.output.gain.setValueAtTime(0, 0);
      this.output.gain.linearRampToValueAtTime(this.velocity, this.context.currentTime + attackTime);
      this.output.gain.linearRampToValueAtTime(this.sustain * this.velocity, this.context.currentTime + attackTime + decayTime);
    }
  }, {
    key: "stop",
    value: function stop(time) {
      this.output.gain.cancelScheduledValues(0);
      this.output.gain.linearRampToValueAtTime(0, time + this.release * this.maxTime);
    }
  }, {
    key: "connect",
    value: function connect(destination) {
      this.output.connect(destination);
    }
  }, {
    key: "attack",
    set: function set(value) {
      this._attack = value;
    },
    get: function get() {
      return this._attack;
    }
  }, {
    key: "decay",
    set: function set(value) {
      this._decay = value;
    },
    get: function get() {
      return this._decay;
    }
  }, {
    key: "sustain",
    set: function set(value) {
      this.gain = value;
      this._sustain;
    },
    get: function get() {
      return this.gain;
    }
  }, {
    key: "release",
    set: function set(value) {
      this._release = value;
    },
    get: function get() {
      return this._release;
    }
  }]);

  return AmpEnvelope;
}();

export { AmpEnvelope as default };